import admin from "../../const/admin";
import netcoServer from '../../apis/netcoServer';
import {DELETE_WEBSERVICE_USER} from "../types";
import handleResponse from '../helpers/handleResponse';
import infoPayload from "../helpers/payloadHandlers/infoPayload";
import getAllWebserviceUsers from "./getAllWebserviceUsers";
import loadingCall from "../helpers/loadingCall";

const deleteWebserviceUser= (id) => async (dispatch, getState) => {
  let response = await loadingCall(dispatch, () => netcoServer.newPost('/SystemService/deleteWebserviceUser', {id: id}));
  handleResponse(dispatch, response, DELETE_WEBSERVICE_USER, data => onSuccessPayload(data, getState), null, [getAllWebserviceUsers]);
};

const onSuccessPayload = (data, getState) => {
  return infoPayload('success', admin[getState().auth.language].authorizedIPDeleted);
};
export default deleteWebserviceUser;